//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'skuEditorTable',
    props: {
        columns: {
            type: Array
        }
    }
}

